import type { FSA } from 'types/redux';
import type { TargetsSearchParams } from 'types/trident-campaigns';
import _, { map, get } from 'lodash';
import Toastr from 'utils/toastr-util';
import { API_REQUEST } from 'middlewares/api-middleware';

export const GET_TEMPLATE = 'GET_TEMPLATE_TRIDENT_CAMPAIGNS';
export function getTemplate(params: any): FSA {
  // TODO: /templates/${params.templateID} could be used solely but extra work would be required
  return {
    type: GET_TEMPLATE,
    payload: [
      {
        method: 'GET',
        url: '/templateVariables',
        params,
      },
      {
        method: 'GET',
        url: `/templates/${params?.templateID ?? ''}`,
      },
    ],
    meta: {
      [API_REQUEST]: true,
      templateID: params?.templateID,
      batch: true,
    },
  };
}

export const GET_TEMPLATE_LIST = 'GET_TEMPLATE_LIST_TRIDENT_CAMPAIGNS';
export function getTemplateList(templateIDs: Array<string>): FSA {
  return {
    type: GET_TEMPLATE_LIST,
    payload: map(templateIDs, id => {
      return {
        method: 'GET',
        url: `/templates/${id}`,
      };
    }),
    meta: {
      [API_REQUEST]: true,
      templateIDs,
      batch: true,
    },
  };
}

export const CHANGE_STATUS = 'CHANGE_CAMPAIGN_STATUS';
export function changeCampaignStatus(data: any, countryID: number, campaignID: string): FSA {
  return {
    type: CHANGE_STATUS,
    payload: {
      method: 'PATCH',
      url: `/campaigns/${countryID}/${campaignID}`,
      data,
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

export const GET_REWARD_STATUS = 'GET_REWRAD_STATUS';
export function getValidatedRewardInfo(data: any): FSA {
  return {
    type: GET_REWARD_STATUS,
    payload: {
      method: 'POST',
      url: '/rewards/validate-for-awarding',
      data,
    },
    meta: {
      [API_REQUEST]: true,
      rewardID: data?.rewardID,
    },
  };
}

export const GET_TIME_PROGRESS = 'GET_TIME_PROGRESS';
export function getTimeProgress(params: any): FSA {
  let currentNodeProgressKey = `${params?.countryID ?? ''}${params?.campaignID ?? ''}${params?.nodeID ?? ''}`;
  if ((params?.scheduleID ?? 0) > 0) {
    currentNodeProgressKey = `${params?.scheduleID ?? ''}`;
  }
  return {
    type: GET_TIME_PROGRESS,
    payload: {
      method: 'GET',
      url: '/timeevent/progress',
      params,
    },
    meta: {
      [API_REQUEST]: true,
      currentNodeProgressKey,
    },
  };
}

export const GET_LIST_RULE_TYPE = 'GET_LIST_RULE_TYPE';
export function getListRuleTypes(params: any): FSA {
  return {
    type: GET_LIST_RULE_TYPE,
    payload: {
      method: 'POST',
      url: '/configurations/event-condition-action',
      data: {
        listEventConditionActionRequest: params,
      },
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

// Fetch Event Condition Action configuration by key
export const GET_ECA_CONFIG_BY_KEY = 'GET_ECA_CONFIG_BY_KEY';
export function getECAConfigByKey(key: string): FSA {
  return {
    type: GET_ECA_CONFIG_BY_KEY,
    payload: {
      method: 'POST',
      url: '/configurations/event-condition-action-raw-config',
      data: {
        key: key,
      },
    },
    meta: {
      [API_REQUEST]: true,
      ecaKey: key,
    },
  };
}

export const GET_DYNAMIC_INPUT_TYPES = 'GET_DYNAMIC_INPUT_TYPES';
export function getDynamicInputTypes(params: any): FSA {
  return {
    type: GET_DYNAMIC_INPUT_TYPES,
    payload: {
      method: 'POST',
      url: '/configurations/dynamic-input-types',
      params,
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

export const GET_FEATURE_FLAG_CONFIG = 'GET_FEATURE_FLAG_CONFIG';
export function getFeatureFlagConfig(params: any): FSA {
  return {
    type: GET_FEATURE_FLAG_CONFIG,
    payload: {
      method: 'POST',
      url: '/configurations/feature-flag-config',
      params,
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

export const GET_CAMPAIGN_BUDGET_SOURCES = 'GET_CAMPAIGN_BUDGET_SOURCES';
export function getCampaignBudgetSources(params: any): FSA {
  return {
    type: GET_CAMPAIGN_BUDGET_SOURCES,
    payload: {
      method: 'POST',
      url: '/configurations/budgetSources',
      params,
    },
    meta: {
      [API_REQUEST]: false,
    },
  };
}

export const GET_CAMPAIGN_TARGET_VERTICALS = 'GET_CAMPAIGN_TARGET_VERTICALS';
export function getCampaignTargetVerticals(params: any): FSA {
  return {
    type: GET_CAMPAIGN_TARGET_VERTICALS,
    payload: {
      method: 'POST',
      url: '/configurations/targetVerticals',
      params,
    },
    meta: {
      [API_REQUEST]: false,
    },
  };
}

export const GET_AWARD_POINT_ACTION = 'GET_AWARD_POINT_ACTION';
export function getAwardPointAction(params: any): FSA {
  return {
    type: GET_AWARD_POINT_ACTION,
    payload: {
      method: 'POST',
      url: '/configurations/award-point-action',
      params,
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

export const SEARCH_CAMPAIGN_HISTORY = 'SEARCH_CAMPAIGN_HISTORY';
export function searchCampaignHistory(data: any): FSA {
  return {
    type: SEARCH_CAMPAIGN_HISTORY,
    payload: {
      method: 'POST',
      url: '/campaign-history',
      data,
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

export const GET_FILTER_TYPES = 'GET_FILTER_TYPES';
export function getFilterTypes(): FSA {
  return {
    type: GET_FILTER_TYPES,
    payload: {
      method: 'POST',
      url: '/configurations/filter-types',
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

export const GET_SEGP_CONFIG = 'GET_SEGP_CONFIG';
export function getSegPConfig(): FSA {
  return {
    type: GET_SEGP_CONFIG,
    payload: {
      method: 'POST',
      url: '/configurations/segp-widget-config',
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

export const GET_APPROVAL_FLOW_CONFIG = 'GET_APPROVAL_FLOW_CONFIG';
export function getApprovalFlowConfig(): FSA {
  return {
    type: GET_APPROVAL_FLOW_CONFIG,
    payload: {
      method: 'POST',
      url: '/configurations/approval-flow-config',
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

export const campaignApprovalFlowActions = {
  request: 'request',
  withdraw: 'withdraw',
  reject: 'reject',
  approve: 'approve',
};

export const CAMPAIGN_APPROVAL_FLOW = 'CAMPAIGN_APPROVAL_FLOW';
export function doCampaignApprovalFlowAction(countryID: number, campaignID: string, actionType: string, data: any): FSA {
  const isOmegaBackendAvailable = _.get(window.Grab.config, 'IS_OMEGA_BACKEND_AVAILABLE', true);

  // If the action type is 'approve' and the OMEGA backend is not available, use the Trident backend's endpoint
  const url = (actionType === campaignApprovalFlowActions.approve) && !isOmegaBackendAvailable
    ? `/campaigns/${countryID}/${campaignID}`
    : `/campaigns/${countryID}/${campaignID}/approval/${actionType}`;

  return {
    type: CAMPAIGN_APPROVAL_FLOW,
    payload: {
      method: 'PATCH',
      url,
      data: {
        ...data,
        actionType,
        countryID,
        campaignID,
      },
    },
    meta: {
      [API_REQUEST]: true,
      errorHandler (error, next, action, defaultErrorHandler) {
        const message = get(error, 'response.data');
        if (message) {
          Toastr.error(message);
        }
        defaultErrorHandler(error, next, action);
      },
    },
  };
}


export const GET_APPROVERS = 'GET_APPROVERS';
export function getApprovers(params: any): FSA {
  return {
    type: GET_APPROVERS,
    payload: {
      method: 'GET',
      url: '/approvers',
      params,
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

export const SEND_PREVIEW_MESSAGE = 'SEND_PREVIEW_MESSAGE';
export function sendPreviewMessage(data: any): FSA {
  return {
    type: SEND_PREVIEW_MESSAGE,
    payload: {
      method: 'POST',
      url: '/preview-message',
      data,
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

export const FETCH_PARQUET_USER_ATTRIBUTES = 'FETCH_PARQUET_USER_ATTRIBUTES';
export function fetchParquetUserAttributes(data: any, previewKey: string): FSA {
  return {
    type: FETCH_PARQUET_USER_ATTRIBUTES,
    payload: {
      method: 'POST',
      url: '/parquet-files/fetch-user-attributes',
      data,
    },
    meta: {
      [API_REQUEST]: true,
      previewKey,
    },
  };
}

export const GET_CAMPAIGN_METRICS = 'GET_CAMPAIGN_METRICS';
export function getCampaignMetrics(countryID: number, campaignID: string): FSA {
  return {
    type: GET_CAMPAIGN_METRICS,
    payload: {
      method: 'GET',
      url: `/campaigns/${countryID}/${campaignID}/metrics`,
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

export const GET_CAMPAIGN_NOT_SENT_METRICS = 'GET_CAMPAIGN_NOT_SENT_METRICS';
export function getCampaignNotSentMetrics(countryID: number, campaignID: string): FSA {
  return {
    type: GET_CAMPAIGN_NOT_SENT_METRICS,
    payload: {
      method: 'GET',
      url: `/campaigns/${countryID}/${campaignID}/metrics?notSentIncluded=true`,
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

export const SEARCH_CAMPAIGNS_FULL = 'SEARCH_CAMPAIGNS_FULL';
// searchCampaignsFull is for searching campaigns without any pagination, used for global campaign visualisation
export function searchCampaignsFull(__: string, searchParams: TargetsSearchParams): FSA {
  return {
    type: SEARCH_CAMPAIGNS_FULL,
    payload: {
      method: 'POST',
      url: '/campaigns',
      data: searchParams,
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

export const SAVE_EVENT_CONDITION_ACTION_CONFIGURATIONS = 'SAVE_EVENT_CONDITION_ACTION_CONFIGURATIONS';
export function saveEventConditionActionConfigurations(data: any): FSA {
  return {
    type: SAVE_EVENT_CONDITION_ACTION_CONFIGURATIONS,
    payload: {
      method: 'PUT',
      url: '/configurations/event-condition-action-raw-config',
      data,
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}
